<template>
  <div v-loading="loading" style="height: inherit;">
    <div class="chart-scatter" v-if="formatData">
      <div class="canvas" ref="canvas"></div>
    </div>
    
    <div class="chart-scatter no-data" v-else>散点图-暂无数据</div>
  </div>
</template>

<script>
import mixin from '@/views/preSalePlan/utils/mixin.js'
export default {
  mixins: [mixin],
  props: ['form'],
  data() {
    return {
      chartsData: {},
      $instance: null,
      loading: false
    }
  },
  computed: {
    formatData() {
      let { goodsList, packList, productList } = this.chartsData;
      goodsList = goodsList && goodsList.length && goodsList.map(v=>{
        return [v.analysis, v.num, v.ratio.split('%')[0]];
      });
      packList = packList && packList.length && packList.map(v=>{
        return [v.analysis, v.num, v.ratio.split('%')[0]];
      });
      productList = productList && productList.length && productList.map(v=>{
        return [v.analysis, v.num, v.ratio.split('%')[0]];
      });
      return goodsList && packList &&  productList ? { goodsList, packList, productList } : null
    }
  },
  mounted() {
    this.init();
  },
  methods: {
    async init() {
      this.loading = true;
      let data = {
        planTime: this.form['planTime'],
        storeId: this.form['storeId']
      };
      this.$q.preSalePlan.monthlyAnalysis({data})
      .then(res=>{
        if(res.data) {
          this.chartsData = res.data;
          this.$nextTick(_=>{
            this.formatData && this.render();
          })
        }else{
          this.chartsData = {};
          this.$instance && this.$instance.clear();
        }
        this.loading = false;
      })
      .catch(_=>{
        this.chartsData = {};
        this.$instance && this.$instance.clear();
        this.loading = false;
      })
    },
    render() {
      let $instance = this.$instance;
      $instance && $instance.clear();

      let $canvas = this.$refs['canvas'];
      $instance = this.$echarts.init($canvas);
      this.$instance = $instance;

      let { goodsList, packList, productList } = this.formatData;
      
      var dataSP = goodsList;

      var dataCP = productList;

      var dataBJ = packList;


      var itemStyle = {
          opacity: 0.8,
          shadowBlur: 10,
          shadowOffsetX: 0,
          shadowOffsetY: 0,
          shadowColor: 'rgba(0, 0, 0, 0.5)'
      };

      var option = {
          backgroundColor: '#404a59',
          color: [
              '#dd4444', '#fec42c', '#80F1BE'
          ],
          legend: {
              top: 10,
              data: this.isAllPlan ? ['商品', '产品', '包件'] : ['商品', '产品'],
              textStyle: {
                  color: '#fff',
                  fontSize: 12
              }
          },
          grid: {
              left: '10%',
              right: 150,
              top: '18%',
              bottom: 70
          },
          tooltip: {
              padding: 10,
              backgroundColor: '#222',
              borderColor: '#777',
              borderWidth: 1,
              formatter: function (obj) {
                  var value = obj.value;
                  return '差异率' + '：' + value[0] + '<br>'
                      + obj.seriesName + '：' + value[1] + '<br>'
                      + '占比' + '：' + value[2] + '<br>'
              }
          },
          dataZoom: [
            {
              show: true,
              realtime: true,
              start: 90,
              end: 100,
              bottom: 10,
              textStyle: {
                color: '#ffffff'
              }
            },
            {
              type: 'inside',
              realtime: true,
              start: -0.2,
              endValue: 0.2
            }
          ],
          xAxis: {
              type: 'value',
              name: '差异率',
              nameGap: 16,
              nameTextStyle: {
                  color: '#fff',
                  fontSize: 12
              },
              // max: 1,
              // min: -1,
              splitLine: {
                  show: false
              },
              axisLine: {
                  lineStyle: {
                      color: '#eee'
                  }
              }
          },
          yAxis: {
              type: 'value',
              name: '数量',
              nameLocation: 'end',
              nameGap: 20,
              nameTextStyle: {
                  color: '#fff',
                  fontSize: 12
              },
              axisLine: {
                  lineStyle: {
                      color: '#eee'
                  },
                  onZero: false
              },
              splitLine: {
                  show: false
              },
              position: 'left'
          },
          visualMap: [
              {
                  left: 'right',
                  top: '100%',
                  dimension: 1,
                  min: 0,
                  max: 2,
                  itemWidth: 30,
                  itemHeight: 120,
                  calculable: true,
                  precision: 0.1,
                  text: ['圆形大小：占比'],
                  textGap: 30,
                  textStyle: {
                      color: '#fff'
                  },
                  inRange: {
                      symbolSize: [5, 30]
                  },
                  outOfRange: {
                      symbolSize: [5, 30],
                      color: ['rgba(255,255,255,.2)']
                  },
                  controller: {
                      inRange: {
                          color: ['#c23531']
                      },
                      outOfRange: {
                          color: ['#444']
                      }
                  }
              }
          ],
          series: this.isAllPlan ? [
              {
                  name: '商品',
                  type: 'scatter',
                  itemStyle: itemStyle,
                  data: dataSP
              },
              {
                  name: '产品',
                  type: 'scatter',
                  itemStyle: itemStyle,
                  data: dataCP
              },
              {
                  name: '包件',
                  type: 'scatter',
                  itemStyle: itemStyle,
                  data: dataBJ
              }
          ]:
          [
              {
                  name: '商品',
                  type: 'scatter',
                  itemStyle: itemStyle,
                  data: dataSP
              },
              {
                  name: '产品',
                  type: 'scatter',
                  itemStyle: itemStyle,
                  data: dataCP
              }
          ]
      };
      $instance.setOption(option);
      $instance.dispatchAction({
        type: 'legendInverseSelect'
      });
      $instance.dispatchAction({
        type: 'legendSelect',
        name: '产品'
      });
    }
  }
}
</script>

<style lang="stylus" scoped>
  .canvas
    width 100%
    height 100%
    background #ffffff
</style>